import { ScreenName, ScreenSetId } from '@/types'

const upgrade = {
  id: ScreenSetId.Upgrade,
  screens: [
    { id: ScreenName.Upgrade, name: 'Upgrade Available' },
    { id: ScreenName.UpgradeConfirmation, name: 'Confirmation' }
  ]
}

// Trial Timeline is composed in conditionally (see ScreenStore.setTrialTimelineVisible) because
// whether a plan has a trial isn't known until the plan/coupon are resolved later in the guard chain.
const checkout = {
  id: ScreenSetId.Checkout,
  screens: [
    { id: ScreenName.PaymentMethod, name: 'Payment method' },
    { id: ScreenName.Confirmation, name: 'Confirmation' }
  ]
}

const nfr = {
  id: ScreenSetId.NoPayPlan,
  screens: [
    { id: ScreenName.NoPayPlanPaymentMethod, name: 'Accept Offer' },
    { id: ScreenName.NoPayPlanConfirmation, name: 'Confirmation' }
  ]
}

const offer = {
  id: ScreenSetId.Offer,
  screens: [
    { id: ScreenName.Offer, name: 'Upgrade Available' },
    { id: ScreenName.OfferConfirmation, name: 'Confirmation' }
  ]
}

const existing = {
  id: ScreenSetId.Existing,
  screens: [{ id: ScreenName.Existing, name: '' }]
}

export default [upgrade, checkout, nfr, offer, existing]
